exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.brand-image[data-v-4f5a124a]{\n  height: 100px;\n  margin-right: 20px;\n}\n.brand-text[data-v-4f5a124a]{\n  font-size: 35px;\n}\n", ""]);

// exports
